/**
 * GPU 사용량 차트의 색·마크 규약이다. 렌더러에 의존하지 않고 CSS 변수 문자열만 다룬다.
 *
 * 값을 TS 리터럴로 두지 않는 이유는 다른 차트 화면과 같다. 테마 전환은 리렌더 없이 CSS 로만
 * 끝나야 한다. 그래야 선 색과 범례 스와치가 같은 프레임에 바뀐다.
 *
 * 두 계열은 같은 대상(GPU-hours)의 두 크기다. 그래서 categorical 팔레트가 아니라 크기 hue 의 두
 * 단계를 쓴다. 사용이 주 마크이고, 보유는 그 상한을 알려 주는 옅은 단계다.
 */
export const USED_COLOR = "var(--app-chart-magnitude)";
export const HELD_COLOR = "var(--app-chart-magnitude-soft)";

export const MARK = {
  /** 선 굵기다. */
  strokeWidth: 2,
  /** 면 채움의 불투명도다. 면은 옅은 바탕이고, 값은 위쪽 선이 말한다. */
  areaOpacity: 0.14,
  /** 축 눈금 글자 크기다. */
  tickFontSize: 11,
  /** 범례 글자 크기다. */
  legendFontSize: 12,
  /** 차트 높이(px)다. 요약 띠의 차트라서 통계 카드의 차트(200)보다 낮다. */
  height: 168,
} as const;
